module.exports = __webpack_public_path__ + "img/study_currencon_bg.73d59875.png";